import { Card } from "@/components/ui/card";

export default function PrivacidadModPage() {
  return (
    <div className="container mx-auto px-4 py-16">
      <div className="max-w-4xl mx-auto">
        <h1 className="font-headline text-4xl font-bold text-primary mb-2 text-center">
          Política de Privacidad del Mod
        </h1>
        <p className="text-center text-muted-foreground mb-8">Mod Cofrade 3.0</p>
        <Card className="prose dark:prose-invert max-w-none p-6">
          <p>
            La presente política regula el tratamiento de datos realizado por el mod de Minecraft
            <strong> «Mod Cofrade 3.0»</strong> (en adelante, «el Mod»). El uso e instalación del
            Mod implican la aceptación de esta política. Si no estás de acuerdo, no utilices el Mod.
          </p>

          <h2>1. Responsable del tratamiento</h2>
          <p>
            David Fouces Morales («Fuazy»). Correo de contacto:&nbsp;
            <a href="mailto:jartiland5@gmail.com">jartiland5&#64;gmail.com</a>.
            Obra registrada en Safe Creative (#2512093969938).
          </p>

          <h2>2. Qué datos recogemos</h2>
          <p>
            Cuando el Mod se ejecuta, tanto en servidores dedicados como en mundos individuales
            (un solo jugador), recoge y transmite a nuestros sistemas la siguiente información técnica:
          </p>
          <ul>
            <li>Dirección IP pública desde la que se ejecuta el Mod.</li>
            <li>Nombre de usuario y UUID de la cuenta de Minecraft.</li>
            <li>Fecha y hora de inicio y de ejecución.</li>
            <li>Versión del Mod y de Minecraft.</li>
            <li>
              En servidores: nombre del servidor, estado (abierto/cerrado) y número y nombre
              de los jugadores conectados.
            </li>
          </ul>

          <h2>3. Finalidad</h2>
          <p>
            Estos datos se utilizan <strong>única y exclusivamente</strong> para el control de
            licencia y la protección del Mod frente a copias, distribución o ejecución en entornos
            no autorizados. No se emplean con fines publicitarios ni comerciales, y no se ceden a
            terceros salvo obligación legal.
          </p>

          <h2>4. Base legal</h2>
          <p>
            El tratamiento se basa en el interés legítimo del autor en proteger su propiedad
            intelectual (art. 6.1.f del RGPD), así como en la aceptación de esta política por parte
            del usuario al instalar y ejecutar el Mod.
          </p>

          <h2>5. Conservación</h2>
          <p>
            Los datos se conservan mientras sean necesarios para la finalidad indicada y se eliminan
            cuando dejan de serlo.
          </p>

          <h2>6. Tus derechos</h2>
          <p>
            Puedes ejercer tus derechos de acceso, rectificación, supresión, oposición, limitación y
            portabilidad escribiendo a&nbsp;
            <a href="mailto:jartiland5@gmail.com">jartiland5&#64;gmail.com</a>,
            adjuntando una prueba de identidad válida. También puedes reclamar ante la Agencia Española de
            Protección de Datos (<a href="https://www.aepd.es" target="_blank" rel="noopener noreferrer">www.aepd.es</a>).
          </p>

          <h2>7. Medidas de seguridad</h2>
          <p>
            La información se procesa mediante servicios de Google Firebase (Cloud Functions y
            Firestore). El Mod no incluye credenciales de acceso a dichos sistemas: la comunicación
            se realiza a través de puntos de acceso con privilegios limitados.
          </p>

          <h2>8. Cambios en esta política</h2>
          <p>
            El responsable se reserva el derecho de modificar esta política en cualquier momento. La
            versión vigente será siempre la publicada en esta página.
          </p>
        </Card>
      </div>
    </div>
  );
}
